import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";
import {
  getAllPlanList,
  getCheckUniqueCompanyNameAction,
  getCheckUniqueEmailAction,
  getCheckUniqueUserNameAction,
  getMaintenanceScreenAction,
  getPublicFeedbackQuestionAction,
  setAllPlanList,
  setCheckUniqueCompanyNameAction,
  setCheckUniqueEmailAction,
  setCheckUniqueUserNameAction,
  setMaintenanceScreenAction,
  setPublicFeedbackQuestionAction,
  setUpdatePublicFeedbackQuestionAction,
  updatePublicFeedbackQuestionAction,
} from "../reducers/publicSlice";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getAllPlanListSaga(): any {
  yield put(setLoaderAction(true));
  console.log("plans-try");
  try {
    const plans = yield call<any>(callAPI, {}, "get", "public/plans");
    console.log("plans-", plans);
    if (plans?.data) {
      yield put(setAllPlanList(plans?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* getCheckUniqueEmailSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const email = action.payload; // Directly access the payload
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `public/exists?email=${email}`
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      // yield put(setDeleteTelnetAction(apiResponse?.message));
      yield put(setCheckUniqueEmailAction(false));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setCheckUniqueEmailAction(true));
  }
  yield put(setLoaderAction(false));
}

function* getCheckUniqueUserNameSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const username = action.payload; // Directly access the payload
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `public/exists?username=${username}`
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      // yield put(setDeleteTelnetAction(apiResponse?.message));
      yield put(setCheckUniqueUserNameAction(false));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setCheckUniqueUserNameAction(true));
  }
  yield put(setLoaderAction(false));
}

function* getCheckUniqueCompanyNameSaga(action: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    const username = action.payload; // Directly access the payload
    const apiResponse = yield call<any>(
      callAPI,
      {},
      "get",
      `public/exists?company=${username}`
    );
    console.log("apiResponse-", apiResponse);
    if (apiResponse?.success === true) {
      yield put(setCheckUniqueCompanyNameAction(false));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setCheckUniqueCompanyNameAction(true));
  }
  yield put(setLoaderAction(false));
}

function* getMaintenanceScreenSaga(): any {
  yield put(setLoaderAction(true));
  console.log("plans-try");
  try {
    const response = yield call<any>(callAPI, {}, "get", "public/web-settings");
    console.log("response-", response);
    if (response?.data) {
      yield put(setMaintenanceScreenAction(response?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* getPublicFeedbackQuestionSaga(payload: any): any {
  yield put(setLoaderAction(true));
  const token = payload?.payload;
  try {
    const headers = {
      Authorization: `Bearer ${token}`, // ✅ attach token in header
    };

    // Make API call
    const response = yield call<any>(
      callAPI,
      { token }, // pass headers as data object (depends on your callAPI function)
      "get",
      "public/feedback"
    );
    console.log("response-", response);
    if (response?.data) {
      yield put(setPublicFeedbackQuestionAction(response?.data));
      // response && handleSuccess(response);
    }
  } catch (error:any) {
    error?.response && handleError(error?.response);
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* updatePublicFeedbackQuestionSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  console.log("payload-", payload);
  const { token, dynamicPayload } = payload?.payload;
  try {
    // Make API call
    const apiResponse = yield call<any>(
      callAPI,
      { payload:dynamicPayload, token }, // pass headers as data object (depends on your callAPI function)
      "post",
      "public/feedback"
    );
    console.log("response-", apiResponse);
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setUpdatePublicFeedbackQuestionAction(true));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

export function* watchPublic() {
  yield takeLatest<any>(getAllPlanList, getAllPlanListSaga);
  yield takeLatest<any>(getCheckUniqueEmailAction, getCheckUniqueEmailSaga);
  yield takeLatest<any>(
    getCheckUniqueUserNameAction,
    getCheckUniqueUserNameSaga
  );
  yield takeLatest<any>(getAllPlanList, getAllPlanListSaga);
  yield takeLatest<any>(getMaintenanceScreenAction, getMaintenanceScreenSaga);
  yield takeLatest<any>(
    getCheckUniqueCompanyNameAction,
    getCheckUniqueCompanyNameSaga
  );
  yield takeLatest<any>(
    getPublicFeedbackQuestionAction,
    getPublicFeedbackQuestionSaga
  );
  yield takeLatest<any>(
    updatePublicFeedbackQuestionAction,
    updatePublicFeedbackQuestionSaga
  );
}
